// Display rules for the economy embed's split bar and its sector shares,
// shared with the og card (SocialCards::SplitBar) so the embed and the card
// agree pixel for pixel.

// Floor for a non-zero sector's segment, in percent of the bar: every
// sector that earned anything stays visible, and the largest segment gives
// up the difference so the bar still sums to the whole day.
export const MIN_BAR_SHARE_PCT = 4

// Segment widths (percent) for the given raw shares (percent) and whether
// each sector earned anything.
export function barWidths(shares: number[], earned: boolean[]): number[] {
    const raw = shares.map(share => Math.min(100, Math.max(0, share)))
    const widths = raw.map((share, i) => (earned[i] ? Math.max(share, MIN_BAR_SHARE_PCT) : 0))
    const extra = widths.reduce((a, b) => a + b, 0) - raw.reduce((a, b) => a + b, 0)
    if (extra > 0) {
        const largest = widths.indexOf(Math.max(...widths))
        widths[largest] = Math.max(0, widths[largest] - extra)
    }
    return widths
}

// A sector that earned anything never reads as nothing: "<1%" instead of a
// rounded-away zero.
export function shareLabel(share: number, earned: boolean): string {
    return earned && share < 0.5 ? '<1%' : `${Math.round(share)}%`
}
